'use client';

import {type ReactNode, useId} from 'react';
import clsx from 'clsx';

import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/modules/foundation/components/accordion';
import {Paragraph} from '@/modules/foundation/components/typography/paragraph';
import {
	ContentBlockContainer,
	type ContentBlockContainerProps,
} from '@/modules/page/components/content-blocks/block-container';

interface Props extends ContentBlockContainerProps {
	heading: string;
	description?: string;
	children?: ReactNode;
	insideToc?: boolean;
}

export const CollapsibleContent = ({heading, description, children, options, insideToc}: Props) => {
	const id = useId();

	return (
		<ContentBlockContainer options={options} insideToc={insideToc}>
			<Accordion
				type="single"
				collapsible
				className={clsx('border', 'rounded-lg', 'p-4', 'md:p-8', 'border-grey-border')}
			>
				<AccordionItem value={id} className={clsx('border-none', 'p-0', 'm-0')}>
					<AccordionTrigger className={clsx('border-none', 'p-0')}>
						<span className={clsx('flex', 'flex-col', 'gap-1')}>
							<span>{heading}</span>
							<Paragraph asChild size="sm" className="font-normal">
								<span>{description}</span>
							</Paragraph>
						</span>
					</AccordionTrigger>
					<AccordionContent className="p-0">{children}</AccordionContent>
				</AccordionItem>
			</Accordion>
		</ContentBlockContainer>
	);
};
